module.exports = __webpack_public_path__ + "fonts/Nexa-Light.df1ef62.woff2";